var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgRedeem = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.5 6h-2.18c.11-.31.18-.65.18-1A2.996 2.996 0 0 0 13 3.35l-.5.67-.5-.68C11.46 2.54 10.55 2 9.5 2c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H4.5c-1.11 0-1.99.89-1.99 2L2.5 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2Zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1Zm-6 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1Zm11 15h-16v-2h16v2Zm0-5h-16V8h5.08L7.5 10.83 9.12 12l2.38-3.24 1-1.36 1 1.36L15.88 12l1.62-1.17L15.42 8h5.08v6Z",
  fill: "currentColor"
})));

export default SvgRedeem;